import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a8eb90e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header",
  "data-test": "header"
}
const _hoisted_2 = {
  class: "nav",
  "data-test": "nav"
}
const _hoisted_3 = { class: "nav__links" }
const _hoisted_4 = { class: "languages_container" }
const _hoisted_5 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_logo = _resolveComponent("app-logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "nav__item",
        to: "/",
        "data-test": "app-logo-router-link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_logo)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "nav__item",
          to: "/",
          "data-test": "home-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("header.home")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "nav__item",
          to: "/about"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("header.about")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          "data-test": "languages",
          class: _normalizeClass(["languages", _ctx.$i18n.locale]),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
            return (_openBlock(), _createElementBlock("option", {
              class: "languages__option",
              key: lang,
              value: lang,
              selected: lang === _ctx.$i18n.locale
            }, _toDisplayString(lang.toUpperCase()), 9, _hoisted_5))
          }), 128))
        ], 2), [
          [_vModelSelect, _ctx.$i18n.locale]
        ])
      ])
    ])
  ]))
}